import COLORS from './colors';

const cobrowseVolumeConfig = {
  name: 'cobrowse_volume',
  title: 'Communication',
  metric: 'cobrowse_volume',
  lines: {
    cobrowse_volume: {
      label: 'Co-browse sessions',
      tooltip: 'A co-browse session counts when it includes an accept and a close.',
      position: 1,
      color: COLORS.green,
    },
    video_volume: {
      label: 'Video sessions',
      tooltip: 'A video session counts when it includes a join and a hangup.',
      position: 2,
      color: COLORS.steel_blue,
    },
    voice_volume: {
      label: 'Voice sessions',
      tooltip: 'A voice session counts when it includes a join and a hangup.',
      position: 3,
      color: COLORS.red,
    },
    screenshare_volume: {
      label: 'Screen share sessions',
      tooltip: 'A screen share session counts when it includes a share and a join.',
      position: 4,
      color: COLORS.yellow,
    },
    inbound_volume: {
      label: 'Inbound sessions',
      tooltip: 'An inbound phone session counts when it includes a join.',
      position: 5,
      color: COLORS.purple,
    },
    outbound_volume: {
      label: 'Outbound sessions',
      tooltip: 'An outbound phone session counts when it includes an initiate.',
      position: 6,
      color: COLORS.orange,
    },
  },
  rightPadding: null,
  leftPadding: null,
  maxTickLabelCount: 8,
};

export default cobrowseVolumeConfig;
